// Generic type for input config objects
export type ConfigInput<T> = {
  [K in keyof T]?: any;
};

// Generic helper function to update config values
export const updateConfigValues = <T extends Record<string, any>>(
  currentConfig: T | null,
  newValues: ConfigInput<T>
): T => {
  const config = currentConfig || ({} as T);
  const updatedConfig = { ...config };

  Object.entries(newValues).forEach(([key, value]) => {
    if (key in updatedConfig) {
      (updatedConfig[key as keyof T] as any).value = value;
    }
  });

  return updatedConfig;
};
